/**
 * Navigation configuration for the application
 * Each route has a path, label, and optional properties
 */

export const publicRoutes = [
  { path: "/", label: "Home" },
  { path: "/features", label: "Features" },
  { path: "/about", label: "About Us" },
  { path: "/resources", label: "Resources" },
  { path: "/contact", label: "Contact us" },

];

export const authRoutes = [
  {
    path: "/auth/login/recruiter",
    label: "Recruiter Login",
    type: "recruiter",
  },
  {
    path: "/auth/login/candidate",
    label: "Candidate Login",
    type: "candidate",
  },
  {
    path: "/auth/signup/recruiter",
    label: "Recruiter Signup",
    type: "recruiter",
  },
  {
    path: "/auth/signup/candidate",
    label: "Candidate Signup",
    type: "candidate",
  },
];

export const protectedRoutes = [
  { path: "/dashboard", label: "Dashboard" },
  { path: "/jobs", label: "Jobs" },
  { path: "/edit_job", label: "Edit Job" },
  { path: "/create_jobs", label: "Create Job" },
  { path: "/HiringPipeline", label: "Hiring Pipeline" },
  { path: "/calender", label: "Calendar" },
  { path: "/calender2", label: "Calendar 2" },
  { path: "/ai_analysis", label: "AI Analysis" },
  { path: "/chat", label: "Chat" },
  { path: "/candidate_emails", label: "Candidate Emails" },
  { path: "/candidate_chat", label: "Candidate Chat" },
  { path: "/profile", label: "Profile" },
  { path: "/notfications", label: "Notfications" },
];

export const footerRoutes = [
  { path: "/privacypolicy", label: "Privacy Policy" },
  { path: "/terms", label: "Terms" },
  { path: "/cookies", label: "Cookies" },
];

// Helper function to check if a route is protected
export const isProtectedRoute = (path) => {
  return protectedRoutes.some((route) => path.startsWith(route.path));
};

// Helper function to check if a route is auth route
export const isAuthRoute = (path) => {
  return path.startsWith("/auth");
};
